"use client";

import { Spinner } from "@radix-ui/themes";

export const RotateSpinnerComponent = () => {
  return (
    <div className="flex justify-center items-center w-[100%] h-[100%]">
      <Spinner />
    </div>
  );
};
